"use client"

import { commonStylesProps } from "@/(admin)/modules/ui-builder/config/lib/commonCSSProps"
import CKEditorWrapper from "@/lib/config/lib/CkeditorWrapper"
import type { ComponentConfig } from "@measured/puck"
import { RenderConfig } from "./RenderConfig"
import type { QuestionAndAnswerProps } from "./types"

const defaultAnswer =
  "From Bulbapedia: Bulbasaur is a small, quadrupedal Pokémon that has blue-green skin with darker patches. It has red eyes with white pupils, pointed, ear-like structures on top of its head, and a short, blunt snout with a wide."

export const QuestionAndAnswer: ComponentConfig<QuestionAndAnswerProps> = {
  label: "Tamda One | Questions And Answers",
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    faqs: {
      label: "Questions",
      type: "array",
      getItemSummary: (item: any, index = 0) => item?.question || `Question ${index + 1}`,
      arrayFields: {
        question: {
          label: "Question",
          type: "text",
        },
        answer: {
          label: "Answer",
          type: "custom",
          render: ({ value, onChange }) => <CKEditorWrapper value={value} onChange={onChange} />,
        },
      },
    },
    ...(commonStylesProps as any),
  },
  defaultProps: {
    title: "QUESTIONS AND ANSWERS",
    faqs: [
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
      {
        question: "Tôi có thể làm thẻ khách hàng Tamda Foods ở đâu?",
        answer: defaultAnswer,
      },
    ],
    className: "",
    styles: {
      mobile: {
        display: "block",
      },
      tablet: {
        display: "block",
      },
      desktop: {
        display: "block",
      },
    },
    responsiveType: "mobileFirst",
    animation: {
      "data-aos": "",
      "data-aos-duration": "",
    },
  },
  ...RenderConfig,
}

export type { QuestionAndAnswerProps }
